module.exports = __webpack_public_path__ + "img/ms-fatigue-cr2.34206c6b.jpg";